import { makeStyles } from '@material-ui/styles';
import FormLabel from '@material-ui/core/FormLabel';
import GridItem from 'components/Grid/GridItem';
import CustomInput from 'components/CustomInput/CustomInput';
import GridContainer from 'components/Grid/GridContainer';
import { useTranslation } from 'react-i18next';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import CardWrapper from 'components/Card/CardWrapper';
import CardBody from 'components/Card/CardBody';
import FormTextInput from 'components/FormTextInput/FormTextInput';
import { RadioGroup } from '@material-ui/core';
import LabeledRadio from 'components/LabeledRadio/LabeledRadio';
import InfoIconTooltip from 'components/InfoIconTooltip/InfoIconTooltip';

const useStyles = makeStyles({
  labelHorizontal: extendedFormsStyle.labelHorizontal,
  radioGroup: {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: '25px',
  },
  flexWrapper: {
    display: 'flex',
  },
  codeContent: {
    marginRight: '4px',
  },
});

const BasicInfoSection = ({
  basicInfoSection,
  setBasicInfoSection,
  isEdit,
  isFreeDelivery,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <CardWrapper title={t('discountCodes.basicInfo')}>
      <CardBody>
        <GridContainer>
          <GridItem sm={6}>
            <FormTextInput
              label={
                <div className={classes.flexWrapper}>
                  <span className={classes.codeContent}>
                    {t('discountCodes.codeContent')} *
                  </span>
                  <InfoIconTooltip
                    title={
                      <div>
                        <p>{t('discountCodes.tooltip1')}</p>
                        <p>{t('discountCodes.tooltip2')}</p>
                        {t('discountCodes.tooltip3')}
                      </div>
                    }
                  />
                </div>
              }
              name="code"
              value={basicInfoSection.code}
              handleChange={e =>
                setBasicInfoSection(prev => ({ ...prev, code: e.target.value }))
              }
            />
          </GridItem>
          <GridItem sm={6}>
            <FormTextInput
              label={t('discountCodes.desc')}
              name="description"
              value={basicInfoSection.description}
              handleChange={e =>
                setBasicInfoSection(prev => ({
                  ...prev,
                  description: e.target.value,
                }))
              }
            />
          </GridItem>
          <GridItem sm={6} style={{ display: isFreeDelivery ? 'none' : null }}>
            <FormLabel className={classes.labelHorizontal}>
              {t('discountCodes.discountCodeValue')} *
            </FormLabel>
            <div className={classes.flexWrapper}>
              <CustomInput
                inputProps={{
                  name: 'value',
                  value: basicInfoSection.value,
                  onChange: e => {
                    if (!isNaN(e.target.value)) {
                      setBasicInfoSection(prev => ({
                        ...prev,
                        value: e.target.value,
                      }));
                    }
                  },
                  disabled: isEdit,
                }}
              />
              <RadioGroup
                className={classes.radioGroup}
                name="isPercent"
                value={basicInfoSection.isPercent}
                onChange={() => {
                  setBasicInfoSection(prev => ({
                    ...prev,
                    isPercent: !prev.isPercent,
                  }));
                }}
              >
                <LabeledRadio
                  label={t('discountCodes.percentage')}
                  value={true}
                  disabled={isEdit}
                />
                <LabeledRadio
                  label={t('discountCodes.amount')}
                  value={false}
                  disabled={isEdit}
                />
              </RadioGroup>
            </div>
          </GridItem>
          <GridItem sm={6}>
            <FormTextInput
              label={`${t('discountCodes.discountCodesQty')} *`}
              name="amount"
              value={basicInfoSection.amount}
              handleChange={e => {
                setBasicInfoSection(prev => ({
                  ...prev,
                  amount: e.target.value,
                }));
              }}
              disabled={isEdit}
            />
          </GridItem>
        </GridContainer>
      </CardBody>
    </CardWrapper>
  );
};

export default BasicInfoSection;
